import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const NoteIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <SvgIcon
      style={{ transform: `scale(${scale || 1})`, fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M18.702 20C20.524 20 22 18.543 22 16.743v-2.592A2.159 2.159 0 0 1 19.823 12c0-1.19.971-2.15 2.177-2.15l-.001-2.594c0-1.8-1.477-3.257-3.298-3.257H5.3C3.478 4 2 5.457 2 7.257v2.678c1.206 0 2.177.875 2.177 2.066A2.16 2.16 0 0 1 2 14.151v2.592C2 18.543 3.476 20 5.298 20h13.404Z"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.61 16.182H8.39m7.22-4.187H8.39m2.755-4.177H8.39"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export default NoteIcon;
